import { render } from "./ModalBreakpoint.vue?vue&type=template&id=8bcea4d6&ts=true"
import script from "./ModalBreakpoint.vue?vue&type=script&lang=ts"
export * from "./ModalBreakpoint.vue?vue&type=script&lang=ts"

import "./ModalBreakpoint.vue?vue&type=style&index=0&id=8bcea4d6&lang=scss"

import exportComponent from "/home/runner/work/richcle-kyc-fe/richcle-kyc-fe/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__